import { injectable } from 'inversify';

@injectable()
export default class AppController {
  constructor() {}

  boostrap() {
    console.info('AppController');
  }
}
